<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import {mapMutations,mapState} from 'vuex'
export default {
  name: 'App',
  created() {
    let winh = document.documentElement.clientHeight; //窗口高度
    localStorage.setItem("winHei", winh);
    localStorage.setItem("pubImg", "../../static/img/"); //统一图片路径前缀
    localStorage.setItem("pubPostUrl", "https://admin.cqxdzx.com/addons/upmarket/index/"); //统一接口请求地址
  },
  mounted() {
    let that = this;
    that.getTypeList('get_housetype_list', 1); //户型
    that.getTypeList('get_housestyle_list', 2); //装修风格
    that.getTypeList('get_housearea_list', 3); //面积
    that.getTypeList('get_designertype_list', 4); //设计师类型
  },
  methods:{
    ...mapMutations(["changeHouseType","changeHouseStyle","changeHouseArea","changeDsignerType"]),

    //获取分类列表(接口名称，父级方法名)
    getTypeList(taget, ctype) {
      let that = this;
      that.axios({
        method: 'get',
        url: "https://admin.cqxdzx.com/addons/upmarket/index/" + taget,
        data: '',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(resp) {
        let mres = resp.data.data;
        let kindsList = [{
          flag: '',
          name: '全部'
        }];
        if (mres.length > 0) {
          for (var i = 0; i < mres.length; i++) {
            kindsList.push(mres[i])
          }
        }
        if (ctype == 1) {
          that.changeHouseType(kindsList); //改变状态-更新户型
        }
        if(ctype == 2){
          that.changeHouseStyle(kindsList); //改变状态-更新风格
        }
        if(ctype == 3){
          that.changeHouseArea(kindsList); //改变状态-更新面积
        }
        if(ctype == 4){
          that.changeDsignerType(kindsList); //改变状态-更新设计师类型
        }
      }).catch(function(error) {
        console.log('请求失败');
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue